import * as v from 'valibot'
import { getPhoneValidationError } from '@/utils/phone.utils'
import type { CountryCode } from 'libphonenumber-js'

export * from 'valibot'

export interface PhoneOptions {
  message?: string
  countryCode?: CountryCode
}

export function phone(options: PhoneOptions = {}) {
  const { message, countryCode } = options

  return v.rawCheck<string>(({ dataset, addIssue }) => {
    if (typeof dataset.value !== 'string' || !dataset.value) return

    const error = getPhoneValidationError(dataset.value, countryCode)

    if (!error) return

    addIssue({ message: message ?? error })
  })
}

export const dateTimeSecondFractionalSchema = v.pipe(
  v.string(),
  v.regex(
    /^\d{4}-(?:0[1-9]|1[0-2])-(?:[12]\d|0[1-9]|3[01])T(?:0\d|1\d|2[0-3])(?::[0-5]\d){2}(?:\.\d{1,9})?$/u
  )
)
